var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-header'),_c('keep-alive',[(_vm.$route.path=='/work')?_c('router-view'):_vm._e()],1),(_vm.$route.path!='/work')?_c('router-view'):_vm._e(),_c('v-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }